import { PaymentPeriod } from "../enums";

export const isAnnualPeriod = (period?: PaymentPeriod) =>
  period === PaymentPeriod.Year;

export const getPeriodLengthInMonths = (period: PaymentPeriod) => {
  if (period === PaymentPeriod.Month) return 1;
  if (period === PaymentPeriod.HalfYear) return 6;
  if (period === PaymentPeriod.Year) return 12;

  return 1;
};
